module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAKlBMVEVHcEwAydoAyNoAytwAyNoAyNoAyNoAyNsAyNoAyNoAyNoAyNsAyNoAyNqYnzsVAAAADXRSTlMAiPYeWZimd+S5bj/XfFQVCAAAAJ5JREFUGNNjYGBgYK5s0pluwAAGzLl3geAahOd0FwxUQGyuu1CwAMjxhXGuAHXowjiXDBjY7t5VFQSCoLt3Exhs794NAGllvXv3MkPt3bsCIA7j3bvXGeaCOCwOIM5Nhl4Qx/cKiHODAWiYAMuNXgcg5xKEsywKwgErYwuAKAMbwCgAMQDFaBRLUZyD4lAULyA8V4DubdQAAQWVBjioAMpphi5zAJCKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/Pickup@2x.png
// module id = goh4
// module chunks = 69